export const NEXT_PAGE = "NEXT_PAGE";
export const LAST_PAGE = "LAST_PAGE";
export const ALLOW_NEW_REQUEST = "ALLOW_NEW_REQUEST";
export const RESET_LAZY_LOADER = "RESET_LAZY_LOADER";
export const SET_LAST_KEY = "SET_LAST_KEY";

export const receiveNextPage = () => ({type: NEXT_PAGE});

export const setLastPage = (isLastPage) => ({
  type: LAST_PAGE,
  isLastPage
});

export const allowNewRequest = () => ({
  type: ALLOW_NEW_REQUEST
});

export const resetLazyLoader = () => ({
  type: RESET_LAZY_LOADER
});

export const setLastKey = (lastKey) => ({
  type: SET_LAST_KEY,
  lastKey
});

export const nextPage = () => (dispatch, getState) => {
  dispatch(receiveNextPage());
};



// WEBPACK FOOTER //
// ./src/actions/lazyload.js